import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { RuntimeConfigService } from './core/config/runtime-config.service';
import { RUNTIME_CONFIG_PATH } from './core/config/runtime-config.token';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    provideRouter(routes),
    {
      provide: RUNTIME_CONFIG_PATH,
      useValue: environment.runtimeConfigPath,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.siteKeyRecaptcha,
    },
    provideAppInitializer(async () => {
      const runtimeConfigService = inject(RuntimeConfigService);
      await runtimeConfigService.load();
    }),
  ],
};
